export enum ChecklistTypes {
  Incidents = 0,
  MyTrack = 1,
  Evaluation = 2,
  Indicators = 3,
  Jobs = 4,
  Indicator_Updates = 5,
}
